import styled, { css, keyframes } from 'styled-components';
import { Row } from 'reactstrap';

const sizes = {
  desktop: '1100px',
  tablet: '768px',
};

export const media = (Object.keys(sizes) as Array<keyof typeof sizes>).reduce(
  (acc, key) => {
    acc[key] = (style: string) =>
      `@media (min-width: ${sizes[key]}) { ${style} }`;
    return acc;
  },
  {} as { [index: string]: (...args: any[]) => any }
);

const MainLayout = styled(Row)`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1070px;
  /* Mobile Device */
  padding-left: 16px;
  padding-right: 16px;
  justify-content: center;

  ${media.desktop`  
    justify-content: flex-start;
    padding-left: 0px;
    padding-right: 0px;
  `};
`;
export const SearchContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  padding: 0;

  /* Mobile Device */
  /* max-width: 1000px; */
  width: 100%;
  ${media.desktop`  
    max-width: 690px;
  `};
`;
export const SearchPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0;

  /* Mobile Device */
  /* max-width: 1000px; */
  margin-left: 0px;
  width: 100%;

  ${media.desktop`  
    max-width: 320px;
    margin-left: 60px;
  `};
`;

export default MainLayout;
